import LabServiceCollection from "@/collections/LabServiceCollection";
import ScheduleCollection from "./ScheduleCollection";
import TestProcessModel from "@/models/lab/TestProcessModel";

export default class TestProcessCollection extends LabServiceCollection {
  model() {
    return TestProcessModel;
  }

  prepareFilter(CollectionFilter) {
    return CollectionFilter;
  }

  getSchedulableTasks() {
    const collection = new ScheduleCollection();

    if (this.length) {
      this.each(process => {
        process.schedulable_tasks.forEach(item => {
          collection.add(item);
        });
      });
    }
    
    return collection;
  }
}
